import { Tabs } from 'aui';
export interface MarkdownTabItemProp {
  // value: string;
  label: string;
  default?: boolean;
}
export function MarkdownTabItem(props: React.PropsWithChildren<MarkdownTabItemProp>) {
  return (
    <Tabs.TabPane tab={<>{String(props.label)}</>}>
      <div className="markdown-child-root">{props.children}</div>
    </Tabs.TabPane>
  );
}

MarkdownTabItem.attributes = ['label', 'default'] as string[];
MarkdownTabItem.displayName = 'MarkdownTabItem';
